import React from 'react';
import { Heart } from 'lucide-react';

interface BattleHealthBarProps {
  current: number;
  max: number;
  label: string;
  color: 'cyan' | 'pink';
}

export function BattleHealthBar({ current, max, label, color }: BattleHealthBarProps) {
  const percentage = (current / max) * 100;
  const barColor = color === 'cyan' ? 'bg-cyan-400' : 'bg-pink-400';
  const textColor = color === 'cyan' ? 'text-cyan-400' : 'text-pink-400';

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Heart className={`w-4 h-4 ${textColor}`} />
          <span className={`text-sm font-medium ${textColor}`}>{label}</span>
        </div>
        <span className={`text-sm font-mono ${textColor}`}>
          {current}/{max}
        </span>
      </div>
      <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
        <div
          className={`h-full ${barColor} transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}